import { ResponseApi } from './../../../structure/model/response-api';
import { GridObject } from './../../../structure/model/grid-view';
import { MenuDinamico } from './models/menu';
import { Menu } from './../../../shared/menu-items/menu-items';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/app/structure/service/api.service';

const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'},)};

@Injectable({
  providedIn: 'root'
})
export class MenuService {

   constructor(
        private api: ApiService
    ) { }

    getCombo(): Observable<MenuDinamico[]> {
      return this.api.get(`Menu/ListMenuDinamico`)
        .pipe(map(res => <MenuDinamico[]>res.data),
          catchError(error => throwError(error)));
    }

    getList(idusuario: number): Observable<[]> {
      return this.api.get(`Menu/List?idusuario=${idusuario}`)
      .pipe((res: any) => res,
      catchError(error => throwError(error)));
    }

    getListMenuDinamico(): any {
      return this.api.get(`Menu/ListMenuDinamicoRelatorio`)
      .pipe((res: any) => res,
      catchError(error => throwError(error)));
    }


    async onSave(menu: MenuDinamico): Promise<any>  {
      return await this.api.asyncPost(`Menu/Add`, menu)
    }

    async onUpdate(menu: MenuDinamico): Promise<any>  {
      return await this.api.asyncPut(`Menu/Update`, menu)
    }


    getListPaged(obj: GridObject): Observable<ResponseApi> {
      return this.api.post(`Menu/ListPaged`,obj)
          .pipe((res: any) => res,
              catchError(error => throwError(error)));
    }

    getItem(id: number): Observable<MenuDinamico> {
      return this.api.get(`Menu/GetById?id=${id}`)
        .pipe(map(res => <MenuDinamico>res.data),
          catchError(error => throwError(error)));
    }

    onDelete(id: number): Observable<number> {
      return this.api.delete(`Menu/${id}`)
      .pipe((res) => res,
        catchError(error => throwError(error)));
    }


    getListMenuType(): any {
      return this.api.get(`Menu/ListMenuType`)
        .pipe(map(res => <any>res.data),
          catchError(error => throwError(error)));
    }

    getListMenuIcon(): any {
      return this.api.get(`Menu/ListMenuIcon`)
        .pipe(map(res => <any>res.data),
          catchError(error => throwError(error)));
    }

}
